// custom code 
        // var linkUrl = '';
        // var linkText = 'Preview Design';
        // var htmlContent = '<a href="' + linkUrl + '">' + linkText + '</a>';
        // var encodedContent = $('<div />').text(htmlContent).html();
        
let currentVariantTitle = "{{ product.selected_or_first_available_variant.title }}"; // Initialize with the default title


  var variantId = 47125952594202 ;
  var contentColor1 = '';
  var contentColor2 = '';
  $(document).ready(function() {

    var inputValue = '';
      
      $('body').on('click','.slctdval',function(){
        $(this).next('.allvalues').show();
        $('.cstmdrop-arw').css('transform','rotate(180deg)');
      });

     $('body').on('click','.saveData',function(){
            var psrc = $('.crntimg').text();
            $('.loader').show();
            fabric.Image.fromURL(psrc, function(pmyImg) {
                    pmyImg.id = 'pmyimage';
                    pmyImg.scaleToWidth(canvas.width);
                    pmyImg.scaleToHeight(canvas.height);
                    pmyImg.set({ left: 0, top: 0 });
                    pmyImg.set({ zIndex: -1 });
                    pmyImg.selectable = false;
                   canvas.add(pmyImg);
                   canvas.moveTo(pmyImg, 0);
                });
       setTimeout(function(){
          canvas.renderAll();
       }, 1000);
       setTimeout(function(){
          console.log("converted NEW:", canvas.toDataURL());
         $('.canvas-image').val(canvas.toDataURL());
         $('button.product-form__submit').attr('disabled',false);
       }, 3000);
       setTimeout(function(){
         $('button.saveData').attr('disabled',true);
         $('.loader').hide();
       }, 3500);
       
      });

      $('body').on('click','.size-name',function(){
        var rid = $(this).attr('data-input_id');
        $("#" + rid).click();
        $('.allvalues').hide();
        $('.slctdtxt').text($(this).text());
        $('.cstmdrop-arw').css('transform','rotate(0deg)');
        $(this).siblings().removeClass('active-size');
        $(this).addClass('active-size');
      });

      $(document).mouseup(function(e){
        var div = $(".allvalues");
        if (!div.is(e.target)) {
          div.hide();
          $('.cstmdrop-arw').css('transform','rotate(0deg)');
        }
      });
      $('.color-n-1 .color-option span').click(function() {
        var span = $(this);
        $(this).parents('li').siblings().removeClass('active-clr1');
        $(this).parents('li').addClass('active-clr1');
        var backgroundColor = span.css('background-Color');
        $("#customtext").css("color", backgroundColor);
        var bgColor = span.attr('class');
        $('.text-color1').val(bgColor);
      });
      
      $('body').on('click','.color-n-2 .color-option span',function(){
        var span = $(this);
        var bgColor = span.attr('class');
        $('.text-color2').val(bgColor);
        $(this).parents('li').siblings().removeClass('active-clr2');
        $(this).parents('li').addClass('active-clr2');
        var shadow = $(this).attr('style').match(/#[0-9a-fA-F]{3,6}/gi)[0];
        $('#customtext').css('text-shadow', '1px 1px ' + shadow + ', 2px 2px ' + shadow + ', 3px 3px ' + shadow + ', 4px 4px ' + shadow + ', 5px 5px ' + shadow );
      });


    
    
      

    // ------------- RESTORED CODE AfterWards ------------------------
  // background img to canvas and text over it ----------------------++++++++++++++++++++++++++++++++++++++++++++++++
    // SET PRDCT IMAGE TO CANVAS AS BACKGROUND 
var psrc = $('.crntimg').text();
console.log(psrc);
    
   $(document).ready(function() {
      $('body').on('click','.customization_Variants',function(){
          $('.saveData').removeClass('hidden');
          $('button.product-form__submit').attr('disabled',true);
          let selectedValue = $(this)[0].value;
          canvas.clear();
          variantId = $(this).attr('data-prdct-id');
          console.log(variantId);
       
         console.log(psrc);
        if(selectedValue === 'Default'){
            $('.saveData').addClass('hidden');
            $('button.product-form__submit').attr('disabled',false);
           variantId = $(this).attr('data-prdct-id');
           console.log("variant id in", variantId)
           document.getElementById('custom_image_tab_new').style.display = 'none';
           document.getElementById('custom_design_tab_new').style.display = 'none';
           document.getElementById('custom_text_tab_new').style.display = 'none';
           document.getElementById('custom_portrait_tab_new').style.display = 'none';
           document.getElementById('custom_stickers_tab_new').style.display = 'none';
           document.getElementById('custom_3dstickers_tab_new').style.display = 'none';
           document.getElementById('STICKERS').style.display='none';
           document.getElementById('3dSTICKERS').style.display='none';
           document.getElementById('TEXT').style.display='none';
           document.getElementById('IMAGE').style.display='none';
           document.getElementById('DESIGN').style.display='none';
           document.getElementById('PORTRAIT').style.display='none';
          
        }
        else if(selectedValue === 'printing letters 🖨️'){
           variantId = $(this).attr('data-prdct-id');
           console.log("variant id in", variantId)
           document.getElementById('custom_text_tab_new').style.display = 'block';
           document.getElementById('custom_text_tab_new').classList.add('active');
           document.getElementById('TEXT').style.display='block';
           document.getElementById('custom_image_tab_new').style.display = 'none';
           document.getElementById('custom_design_tab_new').style.display = 'none';
           document.getElementById('custom_portrait_tab_new').style.display = 'none';
          document.getElementById('custom_stickers_tab_new').style.display = 'none';
           document.getElementById('STICKERS').style.display='none';
           document.getElementById('IMAGE').style.display='none';
           document.getElementById('DESIGN').style.display='none';
           document.getElementById('PORTRAIT').style.display='none';
        }
        else if(selectedValue === 'drawing letters 🎨'){
           variantId = $(this).attr('data-prdct-id');
           console.log("variant id in", variantId)
           document.getElementById('custom_text_tab_new').style.display = 'block';
           document.getElementById('custom_text_tab_new').classList.add('active');
           document.getElementById('TEXT').style.display='block';
           document.getElementById('custom_image_tab_new').style.display = 'none';
           document.getElementById('custom_design_tab_new').style.display = 'none';
           document.getElementById('custom_portrait_tab_new').style.display = 'none';
          document.getElementById('custom_stickers_tab_new').style.display = 'none';
           document.getElementById('STICKERS').style.display='none';
           document.getElementById('IMAGE').style.display='none';
           document.getElementById('DESIGN').style.display='none';
           document.getElementById('PORTRAIT').style.display='none';
        }
        else if(selectedValue === 'printing picture 🖨️'){
           variantId = $(this).attr('data-prdct-id');
           console.log("variant id in", variantId)
          document.getElementById('custom_image_tab_new').style.display = 'block';
          document.getElementById('custom_image_tab_new').classList.add('active');
          document.getElementById('IMAGE').style.display='block';
           document.getElementById('custom_text_tab_new').style.display = 'none';
           document.getElementById('custom_design_tab_new').style.display = 'none';
          document.getElementById('custom_portrait_tab_new').style.display = 'none';
          document.getElementById('custom_stickers_tab_new').style.display = 'none';
           document.getElementById('STICKERS').style.display='none';
           document.getElementById('TEXT').style.display='none';
           document.getElementById('DESIGN').style.display='none';
           document.getElementById('PORTRAIT').style.display='none';
        }
        else if(selectedValue === 'printing picture & letters 🖨️'){
           variantId = $(this).attr('data-prdct-id');
           console.log("variant id in", variantId)
          document.getElementById('custom_image_tab_new').classList.remove('active');
            document.getElementById('custom_text_tab_new').style.display = 'block';
            document.getElementById('custom_text_tab_new').classList.add('active');
            document.getElementById('TEXT').style.display='block';
           document.getElementById('custom_image_tab_new').style.display = 'block';
           document.getElementById('custom_design_tab_new').style.display = 'none';
          document.getElementById('custom_portrait_tab_new').style.display = 'none';
          document.getElementById('custom_stickers_tab_new').style.display = 'none';
           document.getElementById('STICKERS').style.display='none';
           document.getElementById('PORTRAIT').style.display='none';
           document.getElementById('DESIGN').style.display='none';
           document.getElementById('IMAGE').style.display='none';
        }
        else if(selectedValue === 'drawing picture ( letters FREE )🎨'){
           variantId = $(this).attr('data-prdct-id');
           console.log("variant id in", variantId)
           document.getElementById('custom_image_tab_new').classList.remove('active');
            document.getElementById('custom_text_tab_new').style.display = 'block';
            document.getElementById('custom_text_tab_new').classList.add('active');
            document.getElementById('TEXT').style.display='block';
           document.getElementById('custom_image_tab_new').style.display = 'block';
           document.getElementById('custom_design_tab_new').style.display = 'none';
          document.getElementById('custom_portrait_tab_new').style.display = 'none';
          document.getElementById('custom_stickers_tab_new').style.display = 'none';
           document.getElementById('STICKERS').style.display='none';
           document.getElementById('PORTRAIT').style.display='block';
            document.getElementById('DESIGN').style.display='none';
          
        }
        else if(selectedValue === 'Printing Design & Letters 🖨️'){
           variantId = $(this).attr('data-prdct-id');
           console.log("variant id in", variantId)
            document.getElementById('custom_design_tab_new').classList.remove('active');
            document.getElementById('custom_text_tab_new').style.display = 'block';
           document.getElementById('custom_design_tab_new').style.display = 'block';
            document.getElementById('custom_text_tab_new').classList.add('active');
           document.getElementById('TEXT').style.display='block';
           document.getElementById('custom_image_tab_new').style.display = 'none';
          document.getElementById('custom_portrait_tab_new').style.display = 'none';
          document.getElementById('custom_stickers_tab_new').style.display = 'none';
           document.getElementById('STICKERS').style.display='none';
           document.getElementById('PORTRAIT').style.display='none';
           document.getElementById('IMAGE').style.display='none';
        }else if(selectedValue === 'Stickers'){
           variantId = $(this).attr('data-prdct-id');
           console.log("variant id in", variantId)
            document.getElementById('custom_stickers_tab_new').classList.add('active');
           document.getElementById('STICKERS').style.display='block';
            
          document.getElementById('custom_3dstickers_tab_new').style.display ='none';
           document.getElementById('3dSTICKERS').style.display='none';
           document.getElementById('custom_design_tab_new').style.display = 'none';
           document.getElementById('custom_image_tab_new').style.display = 'none';
          document.getElementById('custom_portrait_tab_new').style.display = 'none';
           document.getElementById('TEXT').style.display='none';
           document.getElementById('DESIGN').style.display='none';
           document.getElementById('PORTRAIT').style.display='none';
           document.getElementById('IMAGE').style.display='none';
        }
          else if(selectedValue === '3D stickers'){
           variantId = $(this).attr('data-prdct-id');
           console.log("variant id in", variantId)
            document.getElementById('custom_3dstickers_tab_new').classList.add('active');
           document.getElementById('3dSTICKERS').style.display='block';

            
            
           document.getElementById('custom_design_tab_new').style.display = 'none';
           document.getElementById('custom_image_tab_new').style.display = 'none';
          document.getElementById('custom_portrait_tab_new').style.display = 'none';
            document.getElementById('custom_stickers_tab_new').style.display = 'none';
           document.getElementById('STICKERS').style.display='none';
           document.getElementById('TEXT').style.display='none';
           document.getElementById('DESIGN').style.display='none';
           document.getElementById('PORTRAIT').style.display='none';
           document.getElementById('IMAGE').style.display='none';
        }
         else if(selectedValue === 'Drawing character 🎨'){
            variantId = $(this).attr('data-prdct-id');
           console.log("variant id in", variantId)
           canvas.clear();
           document.getElementById('custom_portrait_tab_new').style.display = 'block';
           document.getElementById('custom_text_tab_new').classList.add('active');
           document.getElementById('PORTRAIT').style.display='none';
           document.getElementById('IMAGE').style.display='none';
           document.getElementById('TEXT').style.display='block';
           document.getElementById('DESIGN').style.display='none';
           document.getElementById('STICKERS').style.display='none';
           document.getElementById('custom_stickers_tab_new').style.display = 'none';
          document.getElementById('custom_text_tab_new').style.display = 'block';
           document.getElementById('custom_image_tab_new').style.display = 'none';
           document.getElementById('custom_design_tab_new').style.display = 'none';

        }
    });
  });


 // Canvas start Here 
         var canvas = new fabric.Canvas("canvas");
         const objects = canvas.getObjects();
           
        const canvasCenterX = canvas.width / 2;
        const canvasCenterY = canvas.height / 2;
        var textColorVariable = 'black';
        // ===+++
        var $inputField = $('input[name="initial"]');
        var $outputDiv = $('.customtext');
        
      var ffamily = 'Jameel';
      var textObject = new fabric.Text('', {
              fill: textColorVariable,
              left: canvasCenterX,
              top: canvasCenterY,
              fontFamily:ffamily,
              // shadow: new fabric.Shadow({
              //   color: 'green',
              //   offsetX: 1,
              //   offsetY: 1,
              //   blur:0,
              // })
          
          });

    // -----
     let leftValue = 0;
        let topValue = 0
        let rightValue = 0
        let bottomValue = 0
      
        window.onload = function() {
            let image = document.getElementsByClassName('mainmedia-frst');      
            canvas.setHeight(image[0].height);
            canvas.setWidth(image[0].width);
            leftValue = (26 /100 ) * image[0].width;
            topValue = (25 /100 ) * image[0].height;
            rightValue = (40 /100 ) * image[0].width;
            bottomValue = (17.5 /100 ) * image[0].height;
        };

    // background img to canvas and text over it ----------------------++++++++++++++++++++++++++++++++++++++++++++++++
    // SET PRDCT IMAGE TO CANVAS AS BACKGROUND 
// var psrc = $('.crntimg').text();
// console.log(psrc);
// fabric.Image.fromURL(psrc, function(pmyImg) {
//   pmyImg.id = 'pimage';
  //    pmyImg.scaleToWidth(canvas.width);
  // pmyImg.scaleToHeight(canvas.height);
//   pmyImg.set({ left: 0, top: 0 });

//   // Set the zIndex to make the image the background
//   pmyImg.set({ zIndex: -1 });

//   // Make the image non-selectable
//   pmyImg.selectable = false;

//   canvas.add(pmyImg);
// });



    
    // ---------------------------------------------------------+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
      // text input for canvas 

    
    var inputFile = document.getElementById('finput');
    if(inputFile){
inputFile.onchange = function() {
  const imageUrl = window.URL.createObjectURL(inputFile.files[0]);
  console.log("check image uploaded", imageUrl);

  const objects = canvas.getObjects();
  let imageFound = false;

  for (const object of objects) {
    if (object.type === 'image' && object.id === 'image') {
      // If an image with id 'image' is found, remove it
      canvas.remove(object);
    }
  }

  
  fabric.Image.fromURL(imageUrl, function(myImg) {
    myImg.id = 'image';
    myImg.uploaded = 'yes';
    myImg.scaleToWidth(200);
    myImg.scaleToHeight(100);
    canvas.add(myImg);
  });
};
    }
        var imginputFile = document.getElementById('imgfinput');
    if(imginputFile){
imginputFile.onchange = function() {
  const imageUrl = window.URL.createObjectURL(imginputFile.files[0]);
  console.log("check image uploaded", imageUrl);

  const objects = canvas.getObjects();
  let imageFound = false;

  for (const object of objects) {
    if (object.type === 'image' && object.id === 'image') {
      // If an image with id 'image' is found, remove it
      canvas.remove(object);
    }
  }

  fabric.Image.fromURL(imageUrl, function(myImg) {
    myImg.id = 'image';
    myImg.uploaded = 'yes';
    myImg.scaleToWidth(200);
    myImg.scaleToHeight(100);
    canvas.add(myImg);
  });
};
    }

                  // code to insert new line to canvas text 
        //   function addNewLineToLetters(inputValue) {
        //               let output_text = "";
        //               for (let i = 0; i < inputValue.length; i++) {
        //                   output_text += inputValue[i] + "\n";
        //               }
        //               return output_text;
        //               }

        // // ---------

      function verticalizeText(text) {
              // Split the text into individual letters
              const letters = text.split("");
              // Create a new string to store the verticalized text
              let verticalText = "";
              // Iterate over the letters and add them to the verticalized text string, one per line
              for (const letter of letters) {
                verticalText += letter + "\n";
              }
              // Return the verticalized text string
              return verticalText;
            }
    
          function horizontalizeText(verticalText) {
              // Split the vertical text into individual lines
              const lines = verticalText.split("\n");
              // Create a new string to store the horizontalized text
              let horizontalText = "";
              // Iterate over the lines and remove any trailing whitespace
              for (const line of lines) {
                horizontalText += line.trim();
              }
              // Return the horizontalized text string
              return horizontalText;
            }
       
          $("input[name='dimension']").on("change", function() {
            var inputValue = $inputField.val();
           if ($(this).val() === "Horizontal") {
              let horizontalValue =  horizontalizeText(inputValue);
             textObject.set('text', horizontalValue);
             canvas.renderAll();
             console.log("check horizontal", horizontalValue)
            } else{
             let verticalValue =  verticalizeText(inputValue);
              textObject.set('text', verticalValue);
              canvas.renderAll();
           }
          });
    

        // input value change js 
        $inputField.on('input', function() {
         const checkedRadioButton = $("input[name='dimension']:checked");
          const checkedRadioButtonValue = checkedRadioButton.val();
          if (checkedRadioButtonValue === "Horizontal") {
              var inputValue = $inputField.val();
              let horizontalValue =  horizontalizeText(inputValue);
              textObject.set('text', horizontalValue);
               $outputDiv.text(horizontalValue);
               $('.content').val(horizontalValue);
            } else if (checkedRadioButtonValue === "vertical") {
              var inputValue = $inputField.val();
             let verticalValue =  verticalizeText(inputValue);
              textObject.set('text', verticalValue);
               $outputDiv.text(verticalValue);
               $('.content').val(verticalValue);
            }
          
           canvas.add(textObject);
          // const currentDigit = $(this).val().slice(-1);
          // // check if arabic is enabled and ignore english ones 
          // if (lang == true){
          //   if (isEnglishNumeric(currentDigit)) {
          //     $outputDiv.text('');
          //   } else {
          //     $outputDiv.text(removeEnglishNumeric(inputValue));
          //     $('.content').val(inputValue);
          //     console.log(removeEnglishNumeric(inputValue));
          //     canvas.add(textObject);
          //   }
          // }else{
          //   $outputDiv.text(inputValue);
          //   $('.content').val(inputValue);
          //   canvas.add(textObject);
          // }
        
        });
    // language selector 
      //     var lang = false;
      // $('body').on('click','.languageSelector',function(event){
      //   textObject.set('text', '');
      //   canvas.clear();
      //   $(this).siblings().find('label').removeClass('activecc');
      //   $(this).find('label').addClass('activecc');
      //   var lng = $(this).find('label').attr('data-value');
      //   $('.dropdown-menu.ae-hide').removeClass('open');
      //   $('input[name="initial"]').val('');
      //   $('.customtext').text(' ');
      //   if (lng == 'ar'){
      //     $('.pdp-fs-list ul li:not(:first)').hide();
      //     var arbff = $(".pdp-fs-list ul li:first").find("img").attr('src');
      //     $('.selected-font-style img').attr('src', arbff );
      //     $('.prod__option.prod__option--canvasText').addClass('ccClicktoOpenMenu');
      //     lang = true;
      //     $('input[name="initial"]').css({'direction':'rtl','padding-right':'5rem'});
      //   }
      //   else{
      //     $('.pdp-fs-list ul li').show();
      //     $('.prod__option.prod__option--canvasText').removeClass('ccClicktoOpenMenu');
      //     lang = false;
      //     $('input[name="initial"]').css({'direction':'ltr','padding-right':'0rem'});
      //   }
      // });

       // -----------------
        $('body').on('click','.pdp-fs-list',function(){
            $(this).toggleClass("active");
        });
        // ---------------------pass text to div of img -----
        //  function isEnglishNumeric(input) {
        //   return /^[a-zA-Z0-9]+$/.test(input);
        // }
        // function removeEnglishNumeric(text) {
        //   return text.replace(/[\w\d]/g, '');
        // }

      

            // -------------------------------
        // $('body').on('click','.positionImg',function(){
        //     var pos = $(this).attr('data-value');
        //     // console.log(pos);
        //     $('.customtext').removeClass('Vertical_Center Center Right_Bottom Center_Bottom_Small Center_Small');
        //     $('.customtext').addClass(pos);
        //     $(this).parents('div').find('.positionImg').removeClass('active');
        //     $(this).addClass('active');
        //     var po_s = pos.replace(/_/g, ' ');
        //     $('.cc-font-customizable span.selected-value.option-label').text(po_s);
        //   console.log(canvas.toDataURL());
        // });
        // ----------------------
    

        $('body').on('click','.pdp-font-selector ul li',function(){
            var fontstyle = $(this).attr('data-id');
            console.log(fontstyle , "528");
          
            $('.selected-font-style').css('font-family',fontstyle);
            $('.selected-font-style').text($(this).text()); 
          textObject.set('fontFamily', fontstyle);
            canvas.add(textObject);
          console.log(ffamily,'fontstyle');
        });
        // --------------
        // $('body').on('click','.icon-heart-focus',function(){
        //   if (lang == true){
        //   $('#cc_arabic_text_icon .dropdown-menu.ae-hide').toggleClass('open');
        //       console.log(lang);
        //   }
        //   else{
        //     console.log(lang,"language");
        //     $('#cc_en_text_icon .dropdown-menu.ae-hide').toggleClass('open');
        //   }
        // });

        //---------------
      
      //   $('body').on('click','.dropdown-menu li',function(){
      //     var selectedText = $(this).find('span').text();
      //     var $input = $('input[name="initial"]');
      //     var $output = $('.customtext');
      //     if ($input.val().length < 7) {
      //       $input.val($input.val() + selectedText);
      //       $output.text( $input.val());
      //       canvas.clear();
      //       var inputValue = $input.val();
      //       $('.content').val(inputValue);
      //       textObject.set('text', inputValue);
      //       canvas.add(textObject);
      //     }
      // });


        
       // --------color selection ------- // 
      $('body').on('click','.customizer__label.textColor1',function(){
        // $('.content-clr1').val($(this).prev('input').val());
        var crntclr = $(this).css('background-color');
        console.log("check the color",crntclr );
        contentColor1 = crntclr;
        $('.content-clr1').val(contentColor1);
        $('.customtext').css('color',crntclr);
        // $(this).parents('.c_tc_label').find('.selected-value').text($(this).prev('input').val());
        textColorVariable = crntclr;
        textObject.set('fill',crntclr );
        canvas.add(textObject);
      });

    
      // shadow of canvas 
      $('body').on('click','.customizer__label.textColor2',function(){
        // $('.content-clr2').val($(this).prev('input').val());
        var shadowclr = $(this).css('background-color');
          console.log("check the color",shadowclr );
        contentColor2 = shadowclr;
        $('.content-clr2').val(contentColor2);
        // $(this).parents('.c_tc_label').find('.selected-value').text($(this).prev('input').val());
        // inputValue = $('input[name="initial"]').val();
        var shadow = new fabric.Shadow({
        color: shadowclr, // Shadow color
        blur: 0, // Shadow blur
        offsetX: 1, // X offset
        offsetY: 1 // Y offset
        });
        textObject.set('shadow',shadow );
        canvas.add(textObject);
       
      });
    // enable,disable shadow 
$('#shadow').on('change', function () {
  var shadowclr = $('.customizer__label.textColor2').css('background-color');
  contentColor2 = shadowclr;
  

  // Check if the checkbox with id 'shadow' is checked
  if ($('#shadow').is(':checked')) {
    $('.content-clr2').val(contentColor2);
    // Remove the shadow
    var shadow = new fabric.Shadow({
      color: shadowclr,
      blur: 0,
      offsetX: 1,
      offsetY: 1
    });
    textObject.set('shadow', shadow);
  } else {
    $('.content-clr2').val('');
    var shadowclr = '';
    // Add the shadow
    var shadow = new fabric.Shadow({
      color: shadowclr,
      blur: 0,
      offsetX: 1,
      offsetY: 1
    });
    textObject.set('shadow', shadow);
  }

  canvas.add(textObject);
});

      
   $("li.frame_img_wrap").on("click", function() {
  
    const objects = canvas.getObjects();
    console.log("check objects", objects);
    var imageFound = false;
    for (const object of objects) {
      if (object.type === 'image' || object.id === 'myImage') {
        imageFound = true;
        canvas.remove(object)
         var src = $(this).find("img").attr("src");
        console.log("check the src", src)
        fabric.Image.fromURL(src, function(myImg) {
          myImg.id = 'image'
           myImg.scaleToWidth(200);
           myImg.scaleToHeight(100);
          myImg.set({ left: 75, top: 75 });
          canvas.add(myImg);
        });
      }
    }

      // If the image is found, log a message to the console
      if (!imageFound) {
        console.log("entering")
       var src = $(this).find("img").attr("src");
        fabric.Image.fromURL(src, function(myImg) {
          myImg.id = 'image'
           myImg.scaleToWidth(200);
           myImg.scaleToHeight(100);
          myImg.set({ left: 75, top: 75 });
          canvas.add(myImg);
        });
      } 
      });

      canvas.on('object:modified', function(event) {
        $('button.saveData').attr('disabled',false);
          $('button.product-form__submit').attr('disabled',true);
        });
      canvas.on('object:added', function(event) {
        $('button.saveData').attr('disabled',false);
        $('button.product-form__submit').attr('disabled',true);
      });


    // delBtn = document.getElementById('delete')
      // // Hide the delete button until needed
      // delBtn.style.display = 'none'
      // // When a selection is being made
      // canvas.on({
      //   'selection:created': () => {
      //     delBtn.style.display = 'inline-block'
      //   }
      // })
      // // When a selection is cleared
      // canvas.on({
      //   'selection:cleared': () => {
      //     delBtn.style.display = 'none'
      //   }
      // })
      // // Rmove the active object on clicking the delete button
              
      // delBtn.addEventListener('click', e => {
      //     canvas.clear()
      //       });        
      // end deletion of selected canvas 
      $(".img-tab-btnss button").click(function() {
        $(".bulit-images").removeClass("show");
        var i = $(this).index();
           var L = i +2;
        $(".bulit-images:nth-of-type(" + L + ")").addClass("show");
      });
    });


// 

  $('body').on('click','.remove-item', function(event) {
    $(this).html('<span class="loader" style="display:block"></span>');
    console.log('Item removal initiated.');
    // Identify the data-key and content of the clicked item
    var currentItemKey = $(this).attr('data-key');
    var currentItemContent = $(this).closest('.cart-item').data('content');
    var relateditem = $(this).closest('.cart-item').prev('tr').data('key');
     $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
            id: currentItemKey,
            quantity:0
        },
    }).then((response) => {
        $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
            id: relateditem,
            quantity: 0
        },
    }).then((response) => {
         updateCartDisplay();
    });
   });

});
function updateCartDisplay() {
    $.ajax({
        url: window.location.href,
        method: 'GET',
        dataType: 'html',
        success: function(response) {
            $('.cart-count-bubble').html($(response).find('.cart-count-bubble').html());
            // $('.cart-items').html($(response).find('.cart-items').html());
            $('#CartDrawer').html($(response).find('#CartDrawer').html());
            // $('.drawer__footer').html($(response).find('.drawer__footer').html());
       
            $('cart-items').html($(response).find('cart-items').html());
           
          $('.cart__footer').html($(response).find('.cart__footer').html());
          console.log('cart updated');
        },
        error: function(err) {
            console.error('Error updating cart display:', err);
        }
    });
}



// theme script 


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
      
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );
    

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
    
    
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dataset.s_variant_title = this.currentVariant.title;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    // Update the global variant title
      currentVariantTitle = this.currentVariant.title;
    console.log(this.currentVariant.title,'variant value on change ok');
    
    var current_var = this.currentVariant.title;
    if (current_var.includes("Stickered")){
      console.log('stickered',current_var);
      $('.sticker-btn').show();
      $('.sticker-btn').next('div').find('product-form.product-form').hide();
    }
    else{
      $('.sticker-btn').next('div').find('product-form.product-form').show();
      $('.sticker-btn').hide();
      console.log(current_var,'not contains default');
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.className = " ";
        input.innerText = input.getAttribute('value');
      } else {
        input.className = " ";
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
        input.className = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);



// 

